import { useNavigate } from "react-router-dom";
import LogbookCard from "src/components/shared/LogbookCard/LogbookCard";
import { type ILogbookData } from "src/pages/Home/Home.types";

import styles from "./DashboardLogbookCard.module.scss";

interface Props {
  lbid: string;
  data: ILogbookData;
}

const DashboardLogbookCard = ({ lbid, data }: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to the logbook based on the latest entry type
    if (data.latest) {
      const idType = data.lbtype === "logbook" ? "lbeid" : "partid";
      const id = data.latest.lbeid ?? data.latest.partid;
      navigate(`/logbook/${lbid}/${idType}/${id}`, { replace: true });
    } else {
      // No entries, navigate to create new entry
      const idType = data.lbtype === "logbook" ? "lbeid" : "partid";
      if (data.lbtype === "collection") {
        navigate(`/collection/${lbid}`, { replace: true });
      } else {
        navigate(`/logbook/${lbid}/${idType}`, { replace: true });
      }
    }
  };
  // Transform the data to match LogbookCard props
  const cardProps = {
    lbid,
    lbname: data.lbname,
    lbtype: data.lbtype,
    latest: data.latest,
    open: data.latest?.open ?? 0,
    reverify: data.latest?.reverify ?? 0,
    lastentryDate: data.latest?.entrydate?.split(" ")[0] ?? "",
    lastentryTime: data.latest?.entrydate?.split(" ")[1] ?? "",
    status: "active" as const,
    showPreview: false,
  };
  return (
    <div className={styles.logbookCardWrapper} onClick={handleClick}>
      <LogbookCard {...cardProps} />
    </div>
  );
};

export default DashboardLogbookCard;
